export const formatCurrency = (value: number, currency?: string) => {
  // Only support CAD otherwise default to USD
  if (currency === 'CAD') {
    const formatted = new Intl.NumberFormat('en-CA', {
      style: 'currency',
      currency,
    }).format(value);
    // Intl.NumberFormat returns $1,234.56 but we want C$1,234.56
    return formatted.replace('$', 'C$');
  }
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(value);
};

export const formatNumber = (value: number): string => {
  return new Intl.NumberFormat('en-US').format(value);
};

export const formatPercentage = (value: number): string => {
  return `${value.toFixed(2)}%`;
};

export const phone = (value: string) => {
  const cleaned = `${value}`.replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  return match ? `${match[1]}-${match[2]}-${match[3]}` : value;
};
